import { render, staticRenderFns } from "./updateguardian.vue?vue&type=template&id=768d56fb&scoped=true&"
import script from "./updateguardian.vue?vue&type=script&lang=js&"
export * from "./updateguardian.vue?vue&type=script&lang=js&"
import style0 from "./updateguardian.vue?vue&type=style&index=0&id=768d56fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d56fb",
  null
  
)

export default component.exports